/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTasksQuery } from '../../models/get-project-tasks-query';
import { GetProjectTasksQueryResult } from '../../models/get-project-tasks-query-result';

export interface ApiProjectTaskGetProjectTasksPost$Params {
      body?: GetProjectTasksQuery
}

export function apiProjectTaskGetProjectTasksPost(http: HttpClient, rootUrl: string, params?: ApiProjectTaskGetProjectTasksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTasksQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskGetProjectTasksPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTasksQueryResult>;
    })
  );
}

apiProjectTaskGetProjectTasksPost.PATH = '/api/ProjectTask/GetProjectTasks';
